import PropTypes from 'prop-types';

import { getPagePath, trans } from '@spotahome/soyuz/client';

import { Link } from '@spotahome/ui-library';
import FAQAccordion from '@spotahome/ui-library/src/tenant/components/FAQSection/FAQAccordion';

import LandingSection from '../LandingSection';

import './LandingFaqsSection.scss';

const LandingFaqsSection = ({ faqs = [] }) => {
  return (
    <LandingSection
      className="landing-faqs-section__wrapper"
      containerClassName="landing-faqs-section"
    >
      <div className="landing-faqs-section__title-container">
        <h2 className="landing-faqs-section__title">
          {trans('how-it-works.faqs.title')}
        </h2>
        <p className="landing-faqs-section__subtitle">
          {trans('how-it-works.faqs.subtitle')}
        </p>
        <Link href={getPagePath('externals.help-center')} bold>
          {trans('how-it-works.faqs.help-link')}
        </Link>
      </div>
      <FAQAccordion
        data={faqs}
        theme="how-it-works"
        className="landing-faqs-section__faqs-accordion"
      />
    </LandingSection>
  );
};

LandingFaqsSection.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      top: PropTypes.node.isRequired,
      content: PropTypes.node.isRequired,
      isOpened: PropTypes.bool
    })
  ).isRequired
};

export default LandingFaqsSection;
